/**
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import { initDynamicRoute } from '@/router/router-dynamic';
import { Nprogress } from './ce-progress';
import getPageTitle from 'utils/handle_routes';
import defaultSettings from 'settings';
// import { setLoginUrl } from './util';
import { getAccessInstance, getAccessToken, get, set, remove } from '@/utils/access_token'; //, remove
import { rememberVisit } from '@/utils/recent_visit';

import { getTenantInfo } from 'resfull/npgw/cms/site_status';
import { getTmpCode } from 'resfull/npgw/pms/app';
import { addSearchLog } from 'resfull/npgw/search';
import store from 'store';
import { performanceLog } from '@/utils/monitor/performanceLog';

const { isProgressBar } = defaultSettings;

// 调试预留
// const { isProgressBar, loginPrivatePath, routesWhiteList } = defaultSettings;

isProgressBar && Nprogress.start();
// isProgressBar && NextLoading.start();

// .then(result => {
//     // 如果登录菜单和登录状态为空则跳转到401
//     !result && router.push('/401');
// });

function ceTrack (event, data) {
    // 函数式埋点
    console.warn('window', window.ceSensors)
    // pwa 环境 兼容
    if (window && window.ceSensors) {
        window.ceSensors.track(event, data || {})
    }
}

// 「最近使用功能」靠这条记录的 appUrl 跳回去。很多页面（如 /np/app/detail/:appId 添加内容）的数据取决于查询参数
// （appCode、tid、categoryTid ...），只记 path 的话点快捷入口时参数是空的，接口会 400，所以要带上查询参数。
// 登录凭证（token/instance）和体积很大的 setWord 不能存进日志；整条地址太长时退回只记 path
const UNTRACKED_QUERY_KEYS = ['token', 'instance', 'invoke-form', 'setWord'];
const MAX_TRACKED_URL_LENGTH = 1000;
function trackedUrl(router, to) {
    const query = {};
    Object.keys(to.query || {}).forEach(key => {
        if (!UNTRACKED_QUERY_KEYS.includes(key)) query[key] = to.query[key];
    });
    const full = router.resolve({ path: to.path, query }).route.fullPath;
    return full.length > MAX_TRACKED_URL_LENGTH ? to.path : full;
}

export function initPermission(router) {
    // 初始化方法执行
    if( sessionStorage.getItem('invoke-form') !== 'managePanel' ) {//老门户iframe页面不需要获取动态菜单/权限
        initDynamicRoute();
    }else{
        store.commit('routes/setShowMenu', false)
        store.commit('routes/setIsVisual', false)
    }

    router.beforeResolve(async (to, from, next) => {
        console.warn('testrouter12321###', to);
        let item = to.meta?.trackInfo || null
        const { tenantJson, userdata } = store.state.user // 公共属性需要的参数来源
        if (item && tenantJson && userdata) {
            ceTrack('menhu_b_lastmenu_click', {
                application_code: item.application_code || '',
                application_name: item.application_name || '',
                data_source_id: item.data_source_id || '',
                data_source_name: item.data_source_name || '',
                page_source: from.fullPath || ''
              })
              ceTrack('menhu_b_menuview', {
                application_code: item.application_code || '',
                application_name: item.application_name || '',
                data_source_id: item.data_source_id || '',
                data_source_name: item.data_source_name || '',
                page_source: from.fullPath || ''
              })
        }
        performanceLog()
        // 点击菜单埋点
        const { userName, account } = store.state.user.userdata;
        if (to.meta.title) {
            const appUrl = trackedUrl(router, to);
            rememberVisit(to.meta.title, appUrl, to.query);
            addSearchLog({
                application: to.meta.title,
                appUrl,
                userAccount: account ? account : `username:${userName}`,
            }).then(res => {
                console.log('add menu log 添加埋点成功');
            });
        }

        if (to.meta.title) document.title = getPageTitle(to.meta.title);
        let query = {
            instance: getAccessInstance(),
            token: getAccessToken(),
        };
        if (get('invoke-form')) query['invoke-form'] = get('invoke-form');

        Object.assign(to.query, query);
        // console.log(to);
        set('helpLink', to.meta.helpLink || '');

        if (to.params && Object.keys(to.params).length > 0) {
            set('publicPathValues', to.params); // 存储路由携带参数
        } else {
            remove('publicPathValues'); // 清空路由携带参数
        }
        // 登录判定
        const token = getAccessInstance() || getAccessToken();
        // 无token 尝试获取一次，不要999页面
        if (!token) {
            getTenantInfo().then(res => {
                console.log(res, '获取token数据');
                if (to.path.indexOf('/') !== -1 && to.query && to.query.redirect) {
                    next(to.query.redirect);
                } else if ((to.path.indexOf(from.path) !== -1 || from.path.indexOf(to.path) !== -1) && (to.meta.isApp || from.meta.isApp)) {
                    document.title = getPageTitle(to.meta.title);
                    isProgressBar && Nprogress.done();
                } else {
                    next();
                }
            });
        } else {
            if (to.path.indexOf('/') !== -1 && to.query && to.query.redirect) {
                next(to.query.redirect);
            } else if ((to.path.indexOf(from.path) !== -1 || from.path.indexOf(to.path) !== -1) && (to.meta.isApp || from.meta.isApp)) {
                document.title = getPageTitle(to.meta.title);
                isProgressBar && Nprogress.done();
            } else {
                // 新增，如果是定制应用，则需要先鉴权成功再跳转
                const { appCode, menuType } = to.meta;
                console.log(appCode, menuType, 'meta');
                // menutype == 2 或者 开放平台来的
                if (menuType == 2 || (appCode && appCode.toString().includes('openPlateform')) || (appCode && appCode.toString().includes('appCode_'))) {
                    getTmpCode({ appCode }).then(res => {
                        const { ttk } = res.data;
                        // let url = path;
                        if (ttk) {
                            to.meta.ttk = ttk;
                            // if (url.indexOf('?') > -1) {
                            //     url = `${url}&ttk=${ttk}`;
                            // } else {
                            //     url = `${url}?ttk=${ttk}`;
                            // }
                            // to.meta.path = url;
                            console.log(to, '加上ttk的哈哈哈');
                            next();
                        } else {
                            console.log('跳转到B端登录');
                        }
                    });
                } else {
                    next();
                }
            }
        }
        // 如果页面是登录页则跳转登录页面的地址,注意instance的地址返回
        // if (token) {
        //     if (to.path.indexOf('/') !== -1 && to.query && to.query.redirect) {
        //         next(to.query.redirect);
        //     } else if ((to.path.indexOf(from.path) !== -1 || from.path.indexOf(to.path) !== -1) && (to.meta.isApp || from.meta.isApp)) {
        //         document.title = getPageTitle(to.meta.title);
        //         isProgressBar && Nprogress.done();
        //     } else {
        //         next();
        //     }
        // } else {
        //     // 否则跳转到登录页面
        //     if (routesWhiteList.indexOf(to.path) !== -1) {
        //         // 如果跳环页面在列表中直接跳转
        //         next();
        //     } else {
        //         // 否则跳转到对应登录页面
        //         setLoginUrl(next, to);
        //     }
        // }
        isProgressBar && Nprogress.done();
    });

    // 准备增加一个页面切换中的效果
    router.beforeEach((to, from, next) => {
        isProgressBar && Nprogress.start();
        next()
    })

    router.afterEach((to, from) => {
        isProgressBar && Nprogress.done();
    })
}